export const constants = {
	selector: {
		handler: 'data-dropdown-handler',
	},
}
